import { FC } from 'react';
import { Button } from 'react-bootstrap';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import FormContainer from '../../../components/FormContainer';
import { redirectToAuthPortal } from '../../../shared/helpers/authPortal';

/**
 * Public sign-in entry. Login is delegated to the StaticSmashAuth portal
 * ("Log in" → portal); sign-up keeps the local flow ("Sign up" → /signup).
 */
const LoginFormComponent: FC = () => {
    return (
        <FormContainer>
            <Helmet>
                <title>Smash API - Get started</title>
                <meta name="description" content="Log in or sign up to use the Smash API." />
            </Helmet>
            <h5 className="my-5"><strong>Welcome to Smash for Developers</strong></h5>
            <div className="d-grid gap-2">
                <Button variant="primary" onClick={() => redirectToAuthPortal()}>
                    Log in
                </Button>
                <Link to="/signup" className="btn btn-outline-primary">
                    Sign up
                </Link>
            </div>
        </FormContainer>
    );
};

export default LoginFormComponent;
